//  будущим поколениям: soundcloud (и вероятно bc и муберт) использовались в аудио и видео стилях блоков одновременно!
//  при этом как видео блок их грузили ссылкой в react-player, а сейчас грузят эмбдед айфреймом
//  учесть при разработке!
var checkVideoType = function (link) {
    // const ytType = /^.*(you[tube|.be]).*$/
    var ytType = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
    var kscType = /(?:https?:\/\/(?:www\.)?kinescope\.io\/(?:embed\/)?[\w\-]+)/;
    var ytShorts = /^(https?:\/\/)?(www\.)?youtube\.com\/shorts\/[a-zA-Z0-9_-]{11}(\/[^#\s\?&]+)?(\?[^#\s]+)?(#.*)?$/;
    var vk = /^.*(vk\.(com|ru)|vkvideo\.(com|ru)).*$/;
    var scType = /^.*(sound).*$/;
    var vType = /^.*(vime).*$/;
    var bcType = /^.*(bandcamp).*$/;
    var mbType = /^.*(mubert).*$/;
    var scType2 = /^.*(sound).*$/;
    var rtType = /^.*(rutube).*$/;
    var frame = /<iframe\s+[^>]*?><\/iframe>/gm;
    if (link.match(rtType) !== null && link.match(frame) !== null) {
        return 'rt';
    }
    if (kscType.test(link)) {
        return 'ksc';
    }
    if (link.match(ytShorts) !== null) {
        return 'yt';
    }
    if (link.match(ytType) !== null) {
        return 'yt';
    }
    if (link.match(vk) !== null && link.match(frame) !== null) {
        return 'vk';
    }
    if (link.match(scType) !== null) {
        return 'sc';
    }
    if (link.match(vType) !== null) {
        return 'v';
    }
    if (link.match(bcType) !== null) {
        return 'bc';
    }
    if (link.match(mbType) !== null) {
        return 'mb';
    }
    return 'nodata';
};
export default checkVideoType;
//# sourceMappingURL=checkVideoType.js.map//  будущим поколениям: soundcloud (и вероятно bc и муберт) использовались в аудио и видео стилях блоков одновременно!
//  при этом как видео блок их грузили ссылкой в react-player, а сейчас грузят эмбдед айфреймом
//  учесть при разработке!
var checkVideoType = function (link) {
    // const ytType = /^.*(you[tube|.be]).*$/
    var ytType = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
    var kscType = /(?:https?:\/\/(?:www\.)?kinescope\.io\/(?:embed\/)?[\w\-]+)/;
    var ytShorts = /^(https?:\/\/)?(www\.)?youtube\.com\/shorts\/[a-zA-Z0-9_-]{11}(\/[^#\s\?&]+)?(\?[^#\s]+)?(#.*)?$/;
    var vk = /^.*(vk\.(com|ru)|vkvideo\.(com|ru)).*$/;
    var scType = /^.*(sound).*$/;
    var vType = /^.*(vime).*$/;
    var bcType = /^.*(bandcamp).*$/;
    var mbType = /^.*(mubert).*$/;
    var scType2 = /^.*(sound).*$/;
    var rtType = /^.*(rutube).*$/;
    var frame = /<iframe\s+[^>]*?><\/iframe>/gm;
    if (link.match(rtType) !== null && link.match(frame) !== null) {
        return 'rt';
    }
    if (kscType.test(link)) {
        return 'ksc';
    }
    if (link.match(ytShorts) !== null) {
        return 'yt';
    }
    if (link.match(ytType) !== null) {
        return 'yt';
    }
    if (link.match(vk) !== null && link.match(frame) !== null) {
        return 'vk';
    }
    if (link.match(scType) !== null) {
        return 'sc';
    }
    if (link.match(vType) !== null) {
        return 'v';
    }
    if (link.match(bcType) !== null) {
        return 'bc';
    }
    if (link.match(mbType) !== null) {
        return 'mb';
    }
    return 'nodata';
};
export default checkVideoType;
//# sourceMappingURL=checkVideoType.js.map